import Api from "../axios";

export async function getBreakCount(date, empId) {
  return await Api.get(`/short_break_count?date=${date}&employee_id=${empId}`);
}
